var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page2"},[_c('img',{attrs:{"src":require("../../public/settings/images/page2.jpg")}}),_c('div',{staticClass:"footer"},[_c('div',[_vm._v("お知らせ")]),_c('div',[_vm._v(_vm._s(_vm.config.page2_bottom_work))])])])}
var staticRenderFns = []

export { render, staticRenderFns }